export default function slideToggle(element, duration = 300) {
  const isHidden = window.getComputedStyle(element).display === 'none';


  if (isHidden) {
    element.style.removeProperty('display');
    let display = window.getComputedStyle(element).display;
    if (display === 'none') display = 'flex';
    element.style.display = display;

    element.style.paddingBottom = '20px';

    const height = element.scrollHeight;
    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.offsetHeight; // force reflow
    element.style.transition = `height ${duration}ms, padding ${duration}ms`;
    element.style.height = height + 'px';

    setTimeout(() => {
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition');
    }, duration);
  } else {
    element.style.transition = `height ${duration}ms, padding ${duration}ms`;
    element.style.height = element.scrollHeight + 'px';
    element.offsetHeight; // force reflow
    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingBottom = '0px';

    setTimeout(() => {
      element.style.display = 'none';
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition');
      element.style.removeProperty('padding-bottom');
    }, duration);
  }
}